import axios from 'axios';
import { constructServiceURL } from '../../../../../../utils/URLTools';

export const apiCreateNotificationServiceThreshold = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'addNewThresholdDefault',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.post(serviceURL, payload);
};
